import { Directive, ElementRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[simTableActions], [sim-table-actions], sim-table-actions',
  host: {
    class: 'sim-table-actions'
  }
})
export class SimTableActionsDirective {}

export interface RowOutlet {
  viewContainer: ViewContainerRef;
}

@Directive({ selector: '[simRowOutlet]' })
export class SimRowOutletDirective implements RowOutlet {
  constructor(public viewContainer: ViewContainerRef, public elementRef: ElementRef) {}
}

@Directive({ selector: '[simHeaderRowOutlet]' })
export class SimHeaderRowOutletDirective implements RowOutlet {
  constructor(public viewContainer: ViewContainerRef, public elementRef: ElementRef) {}
}

@Directive({ selector: '[simFooterRowOutlet]' })
export class SimFooterRowOutletDirective implements RowOutlet {
  constructor(public viewContainer: ViewContainerRef, public elementRef: ElementRef) {}
}

@Directive({
  selector: 'sim-table-header',
  host: {
    class: 'sim-table-header'
  }
})
export class SimTableHeaderDirective {}

@Directive({
  selector: 'sim-table-footer',
  host: {
    class: 'sim-table-footer'
  }
})
export class SimTableFooterDirective {}
